<template>
  <div class="monitor">
    <div class="capture">
      <div class="left"></div>
      <div class="btn" @click="capture()">
        <i class="icon"></i>
        <span class="txt">抓图上报</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <div class="monitor-alert">
        <!-- 全部警告 -->
        <div class="alert-info all" :class="{ active: allState }">
          <div class="alert-title all-title">全部报警</div>
          <div class="alert-content invade-content" v-if="allData.length > 0">
            <div class="list" v-for="(item, index) in allData" :key="index">
              <div class="list-info">
                <div class="tip">{{ item.alarmName }}</div>
                <div class="list-time">
                  {{ $Common.dateFormatDateThree(item.alarmTime) }}
                </div>
              </div>
              <div class="list-check" @click="check(item, -1)">立即查看</div>
            </div>
          </div>
          <div class="alert-no" v-else>
            <img src="@/assets/img/schoolMonitorCenter2/no-tip.png" alt="" />
            <div class="no-tip">暂无视频报警</div>
          </div>
        </div>
        <!-- 区域入侵 -->
        <div class="alert-info invade" :class="{ active: invadeState }">
          <div class="alert-title invade-title">区域入侵</div>
          <div
            class="alert-content invade-content"
            v-if="invadeData.length > 0"
          >
            <div class="list" v-for="(item, index) in invadeData" :key="index">
              <div class="list-info">
                <div class="tip">{{ item.alarmName }}</div>
                <div class="list-time">
                  {{ $Common.dateFormatDateThree(item.alarmTime) }}
                </div>
              </div>
              <div class="list-check" @click="check(item, 10014)">立即查看</div>
            </div>
          </div>
          <div class="alert-no" v-else>
            <img src="@/assets/img/schoolMonitorCenter2/no-tip.png" alt="" />
            <div class="no-tip">暂无视频报警</div>
          </div>
        </div>
        <!-- 越界报警 -->
        <div class="alert-info beyond" :class="{ active: beyondState }">
          <div class="alert-title beyond-title">越界警报</div>
          <div
            class="alert-content beyond-content"
            v-if="beyondData.length > 0"
          >
            <div class="list" v-for="(item, index) in beyondData" :key="index">
              <div class="list-info">
                <div class="tip">{{ item.alarmName }}</div>
                <div class="list-time">
                  {{ $Common.dateFormatDateThree(item.alarmTime) }}
                </div>
              </div>
              <div class="list-check" @click="check(item, 10013)">立即查看</div>
            </div>
          </div>
          <div class="alert-no" v-else>
            <img src="@/assets/img/schoolMonitorCenter2/no-tip.png" alt="" />
            <div class="no-tip">暂无视频报警</div>
          </div>
        </div>
        <!-- 人员密度 -->
        <div class="alert-info gather" :class="{ active: gatherState }">
          <div class="alert-title gather-title">人员密度</div>
          <!-- <div class="alert-content gather-content">
            <div class="list">
              <div class="list-info">
                <div class="tip">区域入侵警报，有人翻越围栏。。。</div>
                <div class="list-time">
                  2022-2-16 08:88
                </div>
              </div>
              <div class="list-check">查看详情</div>
            </div>
          </div> -->
          <div
            class="alert-content gather-content"
            v-if="gatherData.length > 0"
          >
            <div class="list" v-for="(item, index) in gatherData" :key="index">
              <div class="list-info">
                <div class="tip">{{ item.alarmName }}</div>
                <div class="list-time">
                  {{ $Common.dateFormatDateThree(item.alarmTime) }}
                </div>
              </div>
              <div class="list-check" @click="check(item, 10026)">查看详情</div>
            </div>
          </div>
          <div class="alert-no" v-else>
            <img src="@/assets/img/schoolMonitorCenter2/no-tip.png" alt="" />
            <div class="no-tip">暂无视频报警</div>
          </div>
        </div>
      </div>
    </div>
    <div class="alert-detail" v-if="imgUrl != '' && alertDialog">
      <div class="mask" @click="alertDialog = false"></div>
      <div class="alert-content">
        <div class="alert-close" @click="alertDialog = false">关闭</div>
        <div class="alert-title">报警详情图</div>
        <div class="alert-img">
          <img :src="$store.state.config.fileUrl + imgUrl" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "momitorAlert",
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      allData: [], // 全部报警
      invadeData: [], // 区域入侵
      beyondData: [], // 越界报警
      gatherData: [], // 人员密度
      allState: false,
      invadeState: false,
      beyondState: false,
      gatherState: false,
      lightState: false,
      imgUrl: "",
      alertDialog: false,
      webSocketBase: "/webscoket/asset",
      webSocketIp: "",
      lockReconnect: false, //避免ws重复连接
      webSocket: null, // 判断当前浏览器是否支持WebSocket
      heartCheck: {
        timeout: 5000, //1分钟发一次心跳
        timeoutObj: null,
        serverTimeoutObj: null
      },
      reconnectTimer: null,
      isLeave: false
    };
  },
  created() {
    // 所有报警
    this.getEduSchoolMonitorAlarm();
    // 区域入侵
    this.getEduSchoolMonitorAlarm(10014);
    // 越界报警
    this.getEduSchoolMonitorAlarm(10013);
    // 人员密度
    this.getEduSchoolMonitorAlarm(10026);

    // let schoolId = this.$store.state.schoolId || 0;
    // let eduId = this.$store.state.eduId || 0;
    // let eduType = this.$store.state.eduType || -1;
    // let type = this.$store.state.type || 0;
    // let param =
    //   "?schoolId=" +
    //   schoolId +
    //   "&eduId=" +
    //   eduId +
    //   "&eduType=" +
    //   eduType +
    //   "&type=" +
    //   type;
    // this.webSocketIp =
    //   this.$store.state.config.wsIpConfig + this.webSocketBase + param;

    // this.createWebSocket();

    // window.addEventListener("beforeunload", () => {
    //   if (this.webSocket) {
    //     this.webSocket.close();
    //     clearTimeout(this.reconnectTimer);
    //   }
    // });
  },
  mounted() {},
  computed: {
    captureResize() {
      return this.$store.state.captureResize;
    },
    defaultOption() {
      return {
        step: 0.5, //步长 越大滚动速度越快
        limitMoveNum: 4, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  watch: {},
  methods: {
    capture() {
      this.$store.commit("updateCaptureResize", this.captureResize + 1);
    },
    selectType(num) {
      switch (num) {
        case 10013:
          this.beyondState = true;
          break;
        case 10014:
          this.invadeState = true;
          break;
        case 10026:
          this.gatherState = true;
          break;
        case 10027:
          this.lightState = true;
          break;
        case -1:
          this.allState = true;
          break;
        default:
          break;
      }
      if (num != 10027 && num != -1) {
        this.getEduSchoolMonitorAlarm(num);
      }
      if (num == -1) {
        this.getEduSchoolMonitorAlarm();
      }
    },
    // 获取学校监控报警信息
    async getEduSchoolMonitorAlarm(num) {
      let type = num;
      let schoolId = this.$store.state.schoolId;
      let req = {};
      if (type) {
        req = {
          schoolId: schoolId,
          type: type
        };
      } else {
        req = {
          schoolId: schoolId
        };
      }

      let res = await this.$Http.getEduSchoolMonitorAlarm(req);
      // console.log(res);
      if (res.code == 200) {
        if (!type) {
          this.allData = res.data || [];
        }
        if (type == 10014) {
          this.invadeData = res.data || [];
        }
        if (type == 10013) {
          this.beyondData = res.data || [];
        }
        if (type == 10026) {
          this.gatherData = res.data || [];
        }
      } else if (res.code == 101) {
        if (type == -1) {
          this.allData = [];
        }
        if (type == 10014) {
          this.invadeData = [];
        }
        if (type == 10013) {
          this.beyondData = [];
        }
        if (type == 10026) {
          this.gatherData = [];
        }
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    check(item, num) {
      this.imgUrl = item.alarmPicUrl;
      this.alertDialog = true;
      if (num == 10014) {
        this.invadeState = false;
      } else if (num == 10013) {
        this.beyondState = false;
      } else if (num == 10026) {
        this.gatherState = false;
      } else {
        this.allState = false;
      }
    },
    // 创建 webSockert
    createWebSocket() {
      try {
        if ("WebSocket" in window) {
          // console.log(this.webSocketIp)
          this.webSocket = new WebSocket(this.webSocketIp);
        }
        this.initEventHandle();
      } catch (e) {
        this.reconnect(this.webSocketIp);
        // console.log(e);
      }
    },
    // 连接 webSocket 成功、收到消息、断开等方法
    initEventHandle() {
      this.webSocket.onclose = (e) => {
        // console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
        console.log("ws连接关闭!" + new Date().toLocaleString());
        if (!this.isLeave) {
          this.reconnect(this.webSocketIp);
        }
      };
      this.webSocket.onerror = () => {
        this.reconnect(this.webSocketIp);
        // console.log("ws连接错误!");
      };
      this.webSocket.onopen = () => {
        this.reset(); //心跳检测重置
        this.start(); //心跳检测开始
        console.log("ws连接成功!" + new Date().toLocaleString());
      };
      this.webSocket.onmessage = (event) => {
        //如果获取到消息，心跳检测重置
        this.reset();
        //拿到任何消息都说明当前连接是正常的
        // console.log("ws收到消息啦:" + event.data);
        if (event.data != "连接成功") {
          let infoArray = JSON.parse(event.data);
          if (infoArray.length > 0) {
            infoArray.forEach((element) => {
              this.selectType(element);
            });
          }
        }
      };
    },
    // 重新连接 webSocket
    reconnect(url) {
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      this.reconnectTimer = setTimeout(() => {
        //没连接上会一直重连，设置延迟避免请求过多
        this.createWebSocket(url);
      }, 2000);
    },
    // 重置心跳检测
    reset() {
      clearTimeout(this.heartCheck.timeoutObj);
      clearTimeout(this.heartCheck.serverTimeoutObj);
    },
    // 开始心跳检测
    start() {
      this.heartCheck.timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常

        this.webSocket.send("ping");
        // console.log("ping!")

        this.heartCheck.serverTimeoutObj = setTimeout(() => {
          //如果超过一定时间还没重置，说明后端主动断开了
          this.webSocket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
        }, this.heartCheck.timeout);
      }, this.heartCheck.timeout);
    }
  },
  destroyed() {
    if (this.webSocket) {
      this.isLeave = true;
      this.webSocket.close();
    }
    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = () => {
      this.webSocket.close();
      clearTimeout(this.reconnectTimer);
    };
  }
};
</script>
<style lang="scss" scoped>
.monitor {
  .capture {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 122px;
      height: 46px;
      background: url("~@/assets/img/schoolMonitorCenter2/capture-bg.png")
        center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      .icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url("~@/assets/img/schoolMonitorCenter2/capture-icon.png")
          center center no-repeat;
        background-size: 100% 100%;
      }
      .txt {
        margin-left: 5px;
        display: inline-block;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
    }
    .left {
      width: 252px;
      height: 20px;
      background: url("~@/assets/img/schoolMonitorCenter2/title-left.png")
        center center no-repeat;
      background-size: 100% 100%;
    }
    .right {
      width: 252px;
      height: 20px;
      background: url("~@/assets/img/schoolMonitorCenter2/title-right.png")
        center center no-repeat;
      background-size: 100% 100%;
    }
  }
  .monitor-alert {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .alert-info {
    width: 445px;
    height: 306px;
    padding: 16px 20px;
    background: url("~@/assets/img/schoolMonitorCenter2/alert-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
    box-shadow: 0px 1px 31px 0px #3cccfb inset;
    &.active {
      background: url("~@/assets/img/schoolMonitorCenter2/alert-tip-bg.png")
        center center no-repeat;
      background-size: 100% 100%;
      animation: twinkle 1s infinite;
      .alert-content {
        .list-check {
          color: #ffc8cb;
        }
      }
    }
    .alert-title {
      // margin: 0 auto 20px auto;
      // width: 84px;
      height: 20px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6ff3fa;
    }
    .alert-content {
      padding: 16px;
      height: 242px;
      overflow-y: scroll;
      scrollbar-width: none;
      /deep/ .list {
        .list-time {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          line-height: 17px;
        }
        .list-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // font-size: 12px;
          // font-family: PingFangSC-Medium, PingFang SC;
          // font-weight: 500;
          // color: #ffffff;
          // line-height: 17px;
        }
        .tip {
          width: 270px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #cecece;
          position: relative;
          &::before {
            display: inline-block;
            width: 2px;
            height: 12px;
            content: "";
            border: 2px left solid;
            background: #ff3636;
            border-radius: 2px;
            position: absolute;
            top: 5px;
            left: -10px;
          }
        }
        .list-check {
          margin: 4px 0 9px 0;
          width: 57px;
          height: 19px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #07f6f9;
          line-height: 19px;
          cursor: pointer;
        }
      }
    }
    .alert-no {
      width: 100%;
      height: 242px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 95px;
        height: 95px;
      }
      .no-tip {
        margin-top: 12px;
        margin-bottom: 6px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #cecece;
        letter-spacing: 1px;
        letter-spacing: 1px;
      }
      .tip {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e9edff;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }
  }
}
@keyframes twinkle {
  0% {
    box-shadow: 0px 0px 0px 0px #ff0000 inset;
  }
  25% {
    box-shadow: 0px 0.25px 13px 0px #ff0000 inset;
  }
  50% {
    box-shadow: 0px 0.5px 27px 0px #ff0000 inset;
  }
  75% {
    box-shadow: 0px 0.75px 40px 0px #ff0000 inset;
  }
  100% {
    box-shadow: 0px 1px 54px 0px #ff0000 inset;
  }
}
@keyframes light1 {
  0% {
    box-shadow: 0px 0px 0px 0px #d4a5fc;
  }
  25% {
    box-shadow: 0px 0.25px 13px 0px #d4a5fc;
  }
  50% {
    box-shadow: 0px 0.5px 27px 0px #d4a5fc;
  }
  75% {
    box-shadow: 0px 0.75px 40px 0px #d4a5fc;
  }
  100% {
    box-shadow: 0px 1px 54px 0px #d4a5fc;
  }
}
@keyframes light2 {
  0% {
    box-shadow: 0px 0px 0px 0px #f8ffd2;
  }
  25% {
    box-shadow: 0px 0.25px 13px 0px #f8ffd2;
  }
  50% {
    box-shadow: 0px 0.5px 27px 0px #f8ffd2;
  }
  75% {
    box-shadow: 0px 0.75px 40px 0px #f8ffd2;
  }
  100% {
    box-shadow: 0px 1px 54px 0px #f8ffd2;
  }
}
@keyframes light3 {
  0% {
    box-shadow: 0px 0px 0px 0px #fa935b;
  }
  25% {
    box-shadow: 0px 0.25px 13px 0px #fa935b;
  }
  50% {
    box-shadow: 0px 0.5px 27px 0px #fa935b;
  }
  75% {
    box-shadow: 0px 0.75px 40px 0px #fa935b;
  }
  100% {
    box-shadow: 0px 1px 54px 0px #fa935b;
  }
}
@keyframes light4 {
  0% {
    box-shadow: 0px 0px 0px 0px #d4a5fc;
  }
  25% {
    box-shadow: 0px 0.25px 13px 0px #d4a5fc;
  }
  50% {
    box-shadow: 0px 0.5px 27px 0px #d4a5fc;
  }
  75% {
    box-shadow: 0px 0.75px 40px 0px #d4a5fc;
  }
  100% {
    box-shadow: 0px 1px 54px 0px #d4a5fc;
  }
}
.alert-detail {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }
  .alert-content {
    width: 780px;
    height: 650px;
    padding: 40px;
    // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -390px;
    margin-left: -325px;
    z-index: 2002;
    .alert-close {
      width: 56px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7deff;
      text-align: center;
      line-height: 25px;
      letter-spacing: 1px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
    .alert-title {
      font-size: 30px;
      color: #ffffff;
      padding-bottom: 20px;
    }
    .alert-img {
      width: 700px;
      height: 500px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
